<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="copy"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g id="Group_567" data-name="Group 567" transform="translate(2.75 2.75)">
      <rect
        id="Rectangle_775"
        data-name="Rectangle 775"
        width="12.833"
        height="12.833"
        rx="1.105"
        transform="translate(3.667 3.667)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1564"
        data-name="Path 1564"
        d="M6.667,15.833H4.833A1.833,1.833,0,0,1,3,14H3V4.833H3A1.833,1.833,0,0,1,4.833,3H14a1.833,1.833,0,0,1,1.833,1.833V6.667"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_1565" data-name="Path 1565" d="M0,0H22V22H0Z" fill="none" />
  </svg>
</template>
